var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-edit-layout',[_c('contacts-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }